export default function filterOutDraftDuplicates(documents) {
  const doesntContainDraft = (published) => !documents.some(
      draft => draft.id === `drafts.${published.id}`);
  return documents.filter(doesntContainDraft)
}
